import React from "react";
import { Image } from "react-bootstrap";
import Loader from '../../assets/images/loader.svg';
import './Spinner.scss';
const Spinner: React.FC = (source?: string) => {
    return (<>
        <div className='pageLoader' data-source={source}>
            <Image className="spinnerLoader" src={Loader} alt="Page Loader" />
        </div>
    </>)
}
export default Spinner;